<template>
  <div>
    <HeroSection
      :title="page.url === 'ty-downloadable-resources' && $store.state.auth.user ? 'Thank You For Downloading The Resource!' : page.title"
      :subtitle="subtitle"
      :desc="page.url === 'ty-downloadable-resources' && $store.state.auth.user ? '' : description"
      :image-url="heroImage"
      :class="[{ higher }, page.url, $route.query.resourcesCategory]"
      :columns="page.url === 'ty-offer-expired' || page.url === 'offer-expired' ? 'col-4' : 'col-6'"
      class="discover-hero"
    >
      <div slot="middle" class="form" :class="{ 'col-8': page.url !== 'offer-expired' }">
        <input
          v-if="page.url !== 'ty-downloadable-resources'"
          v-model="email"
          placeholder="Email Address"
          type="text"
          @input="inputAlert = ''"
        >
        <button class="btn-primary btn-lg" @click="buttonClick">
          {{ buttonTitle }}
        </button>
        <div v-if="page.url !== 'ty-downloadable-resources'" class="input-group checkbox">
          <div>
            <small v-if="inputAlert">{{ inputAlert }}</small>
            <small v-else-if="termsAgreedAlert">{{ termsAgreedAlert }}</small>
            <input
              id="terms"
              v-model="termsAgreed"
              type="checkbox"
              class="custom-checkbox"
            >
            <label for="terms">
              I agree with {{ `${$config.platformName}` }}’s
              <a
                target="_blank" href="https://365datascience.com/terms-of-use/"
              >Terms of Use</a>
              and
              <a
                target="_blank" href="https://365datascience.com/privacy-policy/"
              >Privacy Policy</a>
            </label>
          </div>
        </div>
      </div>
    </HeroSection>
    <div v-if="page.url === 'ty-downloadable-resources' && page.popular && page.popular.length && ($route.query.resourcesCategory && $route.query.resourcesCategory !== 'career-guides')" class="thank-you-resources most-popular">
      <div class="container order-col">
        <h3>Explore More Content</h3>
        <div class="row body">
          <ResourceCard
            v-for="(resource, i) in page.popular"
            :key="i"
            :resource="resource"
            no-pin
            class="col col-3 md-4" :class="`order-${i}`"
            :event="`most_popular_${i + 1}.click`"
          />
        </div>
      </div>
    </div>
    <div v-if="!higher" class="content" :class="page.url">
      <div class="content-background">
        <Lazy never>
          <div class="tips container">
            <div class="container">
              <h2 class="h2">
                {{ tipsTitle }}
              </h2>
              <ol class="row">
                <li v-for="(v, i) in tips" :key="i" class="col col-4">
                  <div class="content">
                    <p class="name h5">
                      {{ v.title }}
                    </p>
                    <span class="description body-1">{{ v.description }}</span>
                    <span class="number">{{ i + 1 }}</span>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </Lazy>
        <Lazy never>
          <GraduatesWork class="site-section container" />
        </Lazy>
        <Lazy never>
          <div class="feedback container">
            <p class="title-review">
              We’ve Helped Over 2M Students to Learn Data Science
            </p>
            <div class="row">
              <div v-for="(review, idx) in reviews" :key="idx" class="col">
                <div class="review">
                  <div class="body">
                    <Rating :scale="review.rating" />
                    <div class="text body-2">
                      {{ review.text }}
                    </div>
                  </div>
                  <div class="info">
                    <img loading="lazy" :src="require(`../assets/images/${review.image}`)" :alt="review.name">
                    <div class="name-country">
                      <div class="name">
                        {{ review.name }} <Check />
                      </div>
                      <div class="country">
                        {{ review.country }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Lazy>
      </div>
      <Lazy never>
        <div class="about">
          <div class="about-author container">
            <p class="title">
              {{ authors.length > 1 ? 'About The Authors' : 'About The Author' }}
            </p>
            <div v-for="(author,index) in authors" :key="index" class="author">
              <img
                loading="lazy"
                class="image" :src="require(`../assets/images/${author.image}`)"
                :alt="author.name"
              >
              <div class="info-author">
                <p class="name h4">
                  {{ author.name }}
                </p>
                <p class="subtitle body-2">
                  {{ author.subtitle }}
                </p>
                <p class="description body-2">
                  {{ author.description.trimStart() }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Lazy>
      <Lazy never>
        <PreFooter
          :title="prefooter.title"
          :description="prefooter.description"
          :button-title="buttonTitle"
          :button-link="`${$route.path}`"
          class="prefooter"
          :dark="true"
          columns="col-8"
        />
      </Lazy>
    </div>
  </div>
</template>

<script>
import HeroSection from '@itbpbg/lms-components/src/components/HeroSection';
import global from '@itbpbg/lms-components/src/mixins/global';
import Lazy from 'vue-lazy-hydration';
import ResourceCard from './Resources/ResourceCard';
import GraduatesWork from '../components/GraduatesWork';
import PreFooter from './PreFooter';
import Rating from './Rating';
import Check from '../assets/svg/icon-check-circle.svg?vue-component';

export default {
  components: {
    HeroSection, Lazy, GraduatesWork, PreFooter, Rating, Check, ResourceCard,
  },
  mixins: [global],
  props: {
    seo: { type: Object, required: true },
  },
  data() {
    return {
      email: '',
      termsAgreed: false,
      inputAlert: '',
      termsAgreedAlert: '',
    };
  },
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [{ rel: 'canonical', href: this.canonicalURL() }],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
  computed: {
    tips() {
      if (['data-science-interview-questions-guide', 'data-science-interview-questions-guide-yt'].includes(this.page.url)) {
        return [
          {
            title: 'Complete',
            description: 'A comprehensive guide containing technical questions, how-to-answer guides, best practices, example replies, and more.',
          },
          {
            title: 'Focused',
            description: 'Helping people launch and advance successful careers as data scientists, analysts, engineers, and architects, and BI analysts.',
          },
          {
            title: 'Expert Advice',
            description: 'Advice from four versed experts who know what it takes to ace a data science interview.',
          },
        ];
      }
      if (['data-science-career-guide', 'data-science-career-guide-yt'].includes(this.page.url)) {
        return [
          {
            title: 'Complete',
            description: 'The most comprehensive guide to data science roles, the job market, required qualifications, interview tips, and all you need to land a job in the field.',
          },
          {
            title: 'Focused',
            description: 'Helping people launch a career as data scientists, analysts, engineers, and architects, and BI analysts.',
          },
          {
            title: 'Expert Advice',
            description: 'Advice from versed experts who know what it takes to build a successful data science career.',
          },
        ];
      }
      if (['data-science-booklet'].includes(this.page.url)) {
        return [
          {
            title: 'Complete',
            description: 'A beginner’s guide to the primary data science methods, goals, applications, job roles, tools, techniques, etc.',
          },
          {
            title: 'Focused',
            description: 'Helping people understand big data, data science, and their primary characteristics.',
          },
          {
            title: 'Created by Experts',
            description: 'The data science 101 explained by industry experts.',
          },
        ];
      }
      if (['data-science-statistics-cheatsheet'].includes(this.page.url)) {
        return [
          {
            title: 'Complete',
            description: 'A cheat sheet with key statistical definitions and formulas, including levels of measurement, types of graphs, p-values, skewness, variance, etc.',
          },
          {
            title: 'Applicable',
            description: 'Helping people grasp fundamental statistical concepts applicable to various fields—data science, economics, psychology, medicine, etc.',
          },
          {
            title: 'Comprehensive',
            description: 'Detailed notes from one our courses covering the essential statistical knowledge for a data science or analytics career.',
          },
        ];
      }
      return [
        {
          title: 'Complete',
          description: 'Step-by-step instructions about how to create various SQL statements in one convenient location.',
        },
        {
          title: 'Focused',
          description: 'Helping people grasp crucial SQL theory and acquire practical skills, essential when working with big data.',
        },
        {
          title: 'Applicable',
          description: 'Covering the basics of the most in-demand skill for data science and analytics jobs.',
        },
      ];
    },
    reviews() {
      if (['data-science-interview-questions-guide', 'data-science-interview-questions-guide-yt'].includes(this.page.url)) {
        return [
          {
            text: 'I just finished reading the guide and WOW! Fantastic answer guide! Very recommended!!',
            name: 'Richard Banks',
            country: 'United Kingdom',
            rating: 5,
            image: 'discover-student_Richard_Banks.jpg',
          },
          {
            text: 'Super comprehensive! Thank you so much for each of the 164 questions and answers! This is the best career resource I\'ve seen.',
            name: 'Goodwin Akpan',
            country: 'South Africa',
            rating: 5,
            image: 'discover-student_Goodwin_Akpan.jpg',
          },
          {
            text: '365 Data Science Program is mind blowing if you are new to the Data Science field and eager to learn the basics. It lays a great foundation to your knowledge on Data Science.',
            name: 'Vikesh Reddy',
            country: 'United States',
            rating: 5,
            image: 'discover-student_Vikesh_Reddy.jpg',
          },
        ];
      }
      if (['data-science-career-guide', 'data-science-career-guide-yt'].includes(this.page.url)) {
        return [
          {
            text: 'You will find the 365 Data Science Career Guide very useful for DS freshers. It will help you to understand what is needed to have a successful career in data science.',
            name: 'Michael Erlihson',
            country: 'Israel',
            rating: 5,
            image: 'discover-student_Michael_Erlihson.jpg',
          },
          {
            text: 'Thank you so much for the guide "Starting a Career in Data Science". It is the best way to learn about this career.',
            name: 'Karen Ann',
            country: 'United Kingdom',
            rating: 5,
            image: 'discover-student_Karen_Ann.jpg',
          },
          {
            text: '365 Data Science Program is mind blowing if you are new to the Data Science field and eager to learn the basics. It lays a great foundation to your knowledge on Data Science.',
            name: 'Vikesh Reddy',
            country: 'United States',
            rating: 5,
            image: 'discover-student_Vikesh_Reddy.jpg',
          },
        ];
      }
      if (['data-science-booklet'].includes(this.page.url)) {
        return [
          {
            text: 'I just finished reading the booklet and WOW! It\'s the best way to start thinking about a career in data science.',
            name: 'José Alvarez',
            country: 'Italy',
            rating: 5,
            image: 'discover-student_José_Alvarez.jpg',
          },
          {
            text: 'Thank you so much for the"Data Science Booklet". It is the best way to learn about this field. ',
            name: 'Wilma Berg',
            country: 'Germany',
            rating: 5,
            image: 'discover-student_Wilma_Berg.jpg',
          },
          {
            text: '365 Data Science Program is mind blowing if you are new to the Data Science field and eager to learn the basics. It lays a great foundation to your knowledge on Data Science.',
            name: 'Vikesh Reddy',
            country: 'United States',
            rating: 5,
            image: 'discover-student_Vikesh_Reddy.jpg',
          },
        ];
      }
      if (['data-science-statistics-cheatsheet'].includes(this.page.url)) {
        return [
          {
            text: 'I just finished reading the cheat sheet and WOW! It\'s the best way to start learning statistics fundamentals.',
            name: 'Maher Nabeel',
            country: 'United Arab Emirates',
            rating: 5,
            image: 'discover-student_Maher_Nabeel.jpg',
          },
          {
            text: 'Thank you so much for the "Statistics Cheat Sheet". It is the best way to learn about descriptive statistics and hypothesis testing.',
            name: 'Anuj Gupta',
            country: 'India',
            rating: 5,
            image: 'discover-student_Anuj_Gupta.jpg',
          },
          {
            text: '365 Data Science Program is mind blowing if you are new to the Data Science field and eager to learn the basics. It lays a great foundation to your knowledge on Data Science.',
            name: 'Vikesh Reddy',
            country: 'United States',
            rating: 5,
            image: 'discover-student_Vikesh_Reddy.jpg',
          },
        ];
      }
      return [
        {
          text: 'I just finished reading the cheat sheet and WOW! It\'s the best way to start learning SQL fundamentals.',
          name: 'Harshita Sharma',
          country: 'Pakistan',
          rating: 5,
          image: 'discover-student_Harshita_Sharma.jpg',
        },
        {
          text: 'Thank you so much for the "SQL Basics Cheat Sheet". It is the best way to learn about this query language.',
          name: 'Ah Lam',
          country: 'China',
          rating: 5,
          image: 'discover-student_Ah_Lam.jpg',
        },
        {
          text: '365 Data Science Program is mind blowing if you are new to the Data Science field and eager to learn the basics. It lays a great foundation to your knowledge on Data Science.',
          name: 'Vikesh Reddy',
          country: 'United States',
          rating: 5,
          image: 'discover-student_Vikesh_Reddy.jpg',
        },
      ];
    },
    authors() {
      if (['data-science-interview-questions-guide'].includes(this.page.url)) {
        return [
          {
            image: 'discover-author_Iliya.jpg',
            name: 'Iliya Valchanov',
            subtitle: 'Co-Founder at 365 Data Science',
            description: 'Iliya co-founded 365 Data Science. He’s a finance graduate with a strong quantitative background. He has won over 90 national and international awards and competitions. Iliya started teaching while at university and continued sharing his data science expertise with aspiring professionals. He authored several 365 Data Science courses in mathematics, statistics, machine learning, and deep learning.',
          },
          {
            image: 'discover-author_Ned.jpg',
            name: 'Ned Krastev',
            subtitle: 'Co-Founder at 365 Data Science',
            description: 'Ned co-founded 365 Data Science. He has a bachelor’s degree in business administration and management, and a master’s in finance from Bocconi University in Milan, Italy. Ned has rich financial advisory experience, gained while working for renowned international companies, such as PwC (Italy), Coca-Cola (United Kingdom), and Infineon Technologies (Germany). He has also authored numerous career resources and courses helping aspiring professionals reach their goals.',
          },
          {
            image: 'discover-author_Elitsa.jpg',
            name: 'Elitsa Kaloyanova',
            subtitle: 'Head of Data Content at 365 Data Science',
            description: 'Ellie is a computational biologist turned data scientist, with expertise in algorithms, data structures, phylogenetics, and population genetics. She has a solid academic background in bioinformatics with publications on constructing phylogenetic networks and trees. Elitsa has authored several 365 Data Science courses on various topics, including data visualization, customer analytics in Python, machine learning, etc.',
          },
          {
            image: 'discover-author_Martin.jpg',
            name: 'Martin Ganchev',
            subtitle: 'Course Instructor at 365 Data Science',
            description: 'Martin holds an MSc in economic and social sciences from Bocconi University in Milan, Italy. His vast experience includes assisting an empirical research for Innocenzo Gasparini Institute of Economic Research and working for the DG Justice and Consumers at the European Commission. Martin has authored some of 365 Data Science’s most successful courses in Python, SQL, Excel, etc.',
          },
        ];
      }
      if (['data-science-statistics-cheatsheet'].includes(this.page.url)) {
        return [
          {
            image: 'discover-author_Iliya.jpg',
            name: 'Iliya Valchanov',
            subtitle: 'Co-Founder at 365 Data Science',
            description: 'Iliya is a finance graduate with a strong quantitative background and a startup entrepreneur. With a formidable affinity for numbers since childhood, he has won over 90 national and international awards and competitions. Iliya started teaching at university, helping others with their statistics and econometrics studies (his first happy students). Co-founder at 365 Data Science and author of several mathematics, statistics, machine learning, and deep learning courses on our platform, Iliya continues sharing his knowledge with students worldwide.',
          },
        ];
      }

      return [
        {
          image: 'discover-author_Iliya.jpg',
          name: 'Iliya Valchanov',
          subtitle: 'Co-Founder at 365 Data Science',
          description: 'Iliya is a finance graduate with a strong quantitative background who chose the exciting path of a startup entrepreneur. He’s one of 365 Data Science’s co-founders and the author of several online courses in mathematics, statistics, machine learning, and deep learning. Iliya has demonstrated a formidable affinity for numbers since childhood, winning more than 90 national and international awards and competitions through the years. He started teaching at university and helped other students with their statistics and econometrics studies. Inspired by his first happy students, he hasn’t stopped helping people worldwide to learn data science.',
        },
      ];
    },
    tipsTitle() {
      if (['data-science-statistics-cheatsheet'].includes(this.page.url)) {
        return 'The Quick-Reference Statistics Cheat Sheet';
      }
      if (['data-science-sql-basics'].includes(this.page.url)) {
        return 'The SQL Basics Cheat Sheet';
      }
      if (['data-science-booklet'].includes(this.page.url)) {
        return 'Understanding Data Science: The Beginner’s Booklet';
      }
      if (['data-science-career-guide', 'data-science-career-guide-yt'].includes(this.page.url)) {
        return 'The Ultimate Data Science Career Guide';
      }
      return 'The Ultimate Insider Data Science Interview Guide';
    },
    heroImage() {
      if (['ty-newsletter', 'ty-offer-expired', 'ty-downloadable', 'ty-downloadable-resources'].includes(this.page.url)) {
        return this.$config.platform === 'fa' ? `fa-discover_ty${this.$store.state.layout === 'mobile' ? '-mobile' : ''}.jpg` : 'discover_ty.jpg';
      }
      return this.$config.platform === 'fa' ? `fa-discover_${this.page.url}${this.$store.state.layout === 'mobile' ? '-mobile' : ''}.jpg` : `discover_${this.page.url}${this.$store.state.layout === 'mobile' ? '-mobile' : ''}.jpg`;
    },
    prefooter() {
      if (['data-science-career-guide', 'data-science-career-guide-yt', 'data-science-booklet'].includes(this.page.url)) {
        return {
          title: 'Are You Considering a Career in Data Science? Smart Move!',
          description: 'Data scientist has been on Glassdoor’s best jobs list since 2015! This booklet will help you understand the data science field and find your ideal career path.',
        };
      }
      if (['data-science-statistics-cheatsheet'].includes(this.page.url)) {
        return {
          title: 'Are You Considering a Career in Data Science? Smart Move!',
          description: 'A solid understanding of statistics is crucial in various lucrative and rewarding fields, including data science, economics, business, etc. With this Statistics Cheat Sheet, you\'ll have quick and easy access to key statistical definitions and formulas.',
        };
      }
      if (['data-science-sql-basics'].includes(this.page.url)) {
        return {
          title: 'Are You Considering a Career in Data Science? Smart Move!',
          description: 'SQL is among the most sought-after skills for data science and analytics jobs. With this comprehensive SQL cheat sheet, you can learn the basics and regularly revise your knowledge.',
        };
      }
      return {
        title: 'So You\'re Applying For A Job In Data Science? Smart Move!',
        description: 'Data Scientist has been named "best job" for four consecutive years by Glassdoor and Harvard Business Review.  With this guide, you\'ll be fully prepared to embark on a new career as a Data Scientist.',
      };
    },
    subtitle() {
      if (this.page.url === 'offer-expired') {
        return 'This offer has expired!';
      }
      return '';
    },
    description() {
      if (['data-science-statistics-cheatsheet'].includes(this.page.url)) {
        return 'Build your confidence when working with data. Learn and revise fundamental descriptive and inferential statistical and hypothesis testing terms and concepts.';
      }
      if (['data-science-interview-questions-guide', 'data-science-interview-questions-guide-yt'].includes(this.page.url)) {
        return 'This extensive guide contains the answers to 164 data science interview questions—from the must-know technical knowledge to role-specific approaches, behavioral questions, and brainteasers. Prepare for anything an interviewer might through at you.';
      }
      if (['data-science-career-guide', 'data-science-career-guide-yt'].includes(this.page.url)) {
        return 'The 365 Data Science career guide contains everything you need to launch a successful career in data science. Download it for free now.';
      }
      if (['data-science-booklet'].includes(this.page.url)) {
        return 'This comprehensive booklet is the ultimate beginner’s guide to data science. It helps you understand what data science is and how everything—from data analysis and predictive analytics to business intelligence and machine learning—fits together to form a unified picture.';
      }
      if (['data-science-sql-basics'].includes(this.page.url)) {
        return 'This comprehensive SQL cheat sheet is the go-to resource for beginners. Learn essential theory and how to create various SQL statements. Brush up your data management skills and refer to our cheat sheet when in doubt.';
      }
      return this.page.metaDescription;
    },
    buttonTitle() {
      if (['offer-expired'].includes(this.page.url)) {
        return 'Awesome! Let Me Know!';
      }
      if (['data-science-interview-questions-guide', 'data-science-interview-questions-guide-yt', 'data-science-career-guide', 'data-science-career-guide-yt'].includes(this.page.url)) {
        return 'Download the Free Guide';
      }
      if (['newsletter'].includes(this.page.url)) {
        return 'Sign me up';
      }
      if (['data-science-booklet'].includes(this.page.url)) {
        return 'Download the Booklet';
      }
      if (['data-science-statistics-cheatsheet', 'data-science-sql-basics'].includes(this.page.url)) {
        return 'Download the Cheat Sheet';
      }
      if (['ty-downloadable-resources'].includes(this.page.url)) {
        return !this.$store.state.auth.user ? 'Create your free account now' : 'Back to Resources';
      }
      return '';
    },
    higher() {
      return ['/offer-expired/', '/newsletter/', '/ty-newsletter/', '/ty-downloadable/', '/ty-downloadable-resources/', '/ty-offer-expired/'].includes(this.$route.path);
    },
  },
  watch: {
    termsAgreed() {
      if (this.termsAgreed) {
        this.termsAgreedAlert = '';
      }
    },
  },
  created() {
    this.page = this.seo;
    this.page.fullPath = `${this.$config.siteUrl}${this.$route.fullPath}`;
  },
  methods: {
    async buttonClick() {
      try {
        if (['ty-downloadable-resources'].includes(this.page.url)) {
          this.$router.push(!this.$store.state.auth.user ? '/signup/' : '/resources-center/');
        }
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!this.email || !re.test(this.email)) {
          this.inputAlert = 'Invalid email';
          return;
        }
        if (!this.termsAgreed) {
          this.termsAgreedAlert = 'Please accept the Privacy Policy';
          return;
        }

        await this.$axios.$post('/pages/send-istag', { email: this.email, page: this.$route.path });

        if ([
          'data-science-interview-questions-guide',
          'data-science-interview-questions-guide-yt',
          'data-science-career-guide',
          'data-science-career-guide-yt',
          'data-science-booklet',
          'data-science-statistics-cheatsheet',
          'data-science-sql-basics',
        ].includes(this.page.url)) {
          this.$store.dispatch('dataLayer/addEvent', { event: 'lp_form_submissions', value: this.page.url });
        }

        if (this.page.url === 'offer-expired') {
          this.$store.dispatch('dataLayer/addEvent', { event: 'offer_expired_form' });
        }

        if (['offer-expired', 'newsletter'].includes(this.page.url)) {
          this.$router.push(`/ty-${this.page.url}/`);
        } else {
          this.$router.push('/ty-downloadable/');
        }

        this.email = '';
        this.termsAgreed = false;
      } catch (error) {
        console.error();
      }
    },
  },
};
</script>

<style lang="scss">
.discover-hero {
  &:before,
  &:after {
    content: none !important;
  }

  .container.image-container {
    height: 760px;
  }

  .wall {
    height: 760px;
  }

  .container:after {
    content: none !important;
  }

  .container .row {
    .heading {
      .h2 {
        font-size: 44px;
        line-height: 110%;
        text-transform: capitalize;
        margin: 0 !important;
      }

      .subtitle {
        font-weight: 500;
        font-size: 24px;
        line-height: 110%;
        text-transform: capitalize;
        margin: var(--spacing-32) 0 0 !important;
        color: var(--main-light) !important;
      }

      .body-2 {
        font-size: 21px;
        line-height: 140%;
        margin-top: var(--spacing-32) !important;
        color: var(--main-light-shade-3) !important;
      }

      .form {
        margin-top: var(--spacing-36);

        button {
          max-width: 100% !important;
          margin: var(--spacing-16) 0 0;
        }

        input {
          border-radius: 5px;
          background: transparent;
          border: 1px solid var(--main-light-shade-4);
          box-sizing: border-box;
          color: var(--main-light-shade-4);
          line-height: 120%;
          top: 24px;

          &::placeholder {
            color: var(--main-light-shade-4);
          }

          &:focus,
          &:active {
            border-color: var(--main-light-shade-3);
          }
        }

        label {
          font-weight: 500;
          color: var(--main-light);

          &:after {
            background-color: unset;
          }
        }

        small {
          color: red;
        }
      }
    }
  }

  &.higher {
    .container.image-container {
      height: 100vh;
    }

    .wall {
      height: 100%;
      width: 100%;

      img {
        height: 100%;
        float: right;
      }
    }
  }

  &.offer-expired {
    .container .heading {
      .h2 {
        margin-top: var(--spacing-44);
        font-size: 44px;
        width: 100%;
      }

      .subtitle {
        font-size: 24px;
        margin-top: var(--spacing-36) !important;
      }

      .body-2 {
        font-size: 18px;
        margin-top: var(--spacing-36);
      }
    }
  }

  &.ty-newsletter,
  &.ty-offer-expired,
  &.ty-downloadable {
    .container {
      .heading {
        h1 {
          font-size: 40px;
        }

        p {
          color: var(--main-light-shade-4) !important;
        }

        .body-2 {
          color: var(--main-light-shade-4) !important;
        }
      }

      .form {
        display: none;
      }
    }
  }

  &.ty-downloadable-resources {
    .btn-primary {
      margin-top: 36px;
      text-align: center;
      max-width: 350px !important;
    }
  }

  &.career-guides {
    .container.image-container {
      height: 100vh !important;
    }
  }
}

.thank-you-resources.most-popular {
  background: var(--main-dark);
  padding-bottom: var(--spacing-140);

  h3 {
    color: var(--main-light);
    margin-bottom: var(--spacing-36);
  }
}

.content {
  .content-background {
    background: var(--main-light-shade-1);

    .tips {
      padding-top: var(--spacing-100);
      padding-bottom: var(--spacing-100);

      h2 {
        width: 48%;
        margin: 0 auto;
        text-align: center;
      }

      ol {
        margin-top: var(--spacing-60);
        padding: 0;
        list-style: none;

        li {
          .content {
            position: relative;
            padding-left: calc(var(--spacing-16) + 14px);
            border-left: 1px solid var(--main-light-shade-3);
            margin-left: 14px;
            height: 100%;

            .h5 {
              margin-top: 0;
              margin-bottom: var(--spacing-16);
            }

            .body-1 {
              display: block;
              padding-right: var(--spacing-36);
              color: var(--main-dark-shade-3);
            }

            .number {
              width: 28px;
              height: 28px;
              line-height: 28px;
              display: block;
              color: var(--main-light);
              background-color: var(--accent-shade-1);
              border-radius: 50%;
              text-align: center;
              position: absolute;
              top: 0;
              left: -14px;
            }
          }
        }
      }
    }

    .site-section {
      padding: 0;

      .container {
        height: 267px !important;
        z-index: 0;
      }

      .content {
        padding: 50px 0 18px;

        .logos {
          justify-content: center;

          svg {
            margin: var(--spacing-8) 25px 18px;
            max-width: 166px;
          }
        }
      }

      .button {
        display: none !important;
      }
    }

    .feedback {
      padding-top: var(--spacing-100);
      padding-bottom: var(--spacing-100);

      .title-review {
        margin-top: 0;
        margin-bottom: var(--spacing-60);
        text-align: center;
        font-weight: 500;
        font-size: 40px;
        line-height: 110%;
      }

      .col {
        .review {
          padding: var(--spacing-30) var(--spacing-30) var(--spacing-36) var(--spacing-30);
          height: 100%;
          background: var(--main-light);
          box-shadow: 0 16px 30px rgba(0, 12, 31, 0.08);
          border-radius: 10px;

          .text {
            margin-top: var(--spacing-16);
            margin-bottom: var(--spacing-24);
          }

          .info {
            display: flex;
            align-items: center;

            .name-country {
              margin-left: var(--spacing-16);

              .name {
                display: flex;
                font-weight: 500;
                font-size: 16px;
                line-height: 150%;

                svg {
                  width: 20px;
                  height: 20px;
                  margin-left: var(--spacing-8);
                }
              }

              img {
                width: 50px;
                height: 50px;
              }

              .country {
                color: var(--main-dark-shade-3);
                line-height: 150%;
              }
            }
          }
        }
      }

      .col:first-child {
        padding-right: 0;
      }

      .col:last-child {
        padding-left: 0;
      }
    }
  }

  .about {
    background: var(--main-dark-light-2);

    .about-author {
      padding-top: var(--spacing-80);
      padding-bottom: var(--spacing-80);

      .title {
        font-weight: 500;
        font-size: 40px;
        line-height: 110%;
        color: var(--main-light);
        text-align: center;
        margin-bottom: 42px;
        margin-top: 0;
      }

      .author {
        display: flex;
        align-items: center;
        margin-bottom: var(--spacing-44);

        .image {
          width: 240px;
          height: 300px;
          border-radius: 5px;
        }

        .info-author {
          margin-left: var(--spacing-32);

          .name {
            margin-bottom: var(--spacing-8);
            color: var(--main-light);
          }

          .subtitle {
            color: var(--main-light);
            margin-top: 0;
            margin-bottom: var(--spacing-32);
          }

          .description {
            color: var(--main-light-shade-4);
            margin: 0;
            white-space: pre-line;
            line-height: 130%;
          }
        }
      }

      .author:last-child {
        margin-bottom: 0;
      }
    }
  }

  .prefooter {
    color: var(--main-light);

    .h2 {
      margin-bottom: var(--spacing-32);
    }

    .content {
      .subtitle {
        margin: 0 auto var(--spacing-32);
      }
    }

    &.dark {
      .subtitle {
        color: var(--main-light-shade-3);
      }
    }

    .bg {
      margin: 27px auto 0 !important;

      &:before {
        background: linear-gradient(90deg, var(--main-dark) 0%, rgba(0, 12, 31, 0.7) 41.67%, rgba(0, 12, 31, 0) 100%);
      }

      &:after {
        background: linear-gradient(270deg, var(--main-dark) 0%, rgba(0, 12, 31, 0.7) 41.67%, rgba(0, 12, 31, 0) 100%);
      }

      svg *[fill="#fff"] {
        fill: var(--main-dark-shade-1);
      }

      svg *[fill="#E6E7E9"] {
        fill: var(--main-dark-shade-2);
      }
    }
  }

  &.data-science-interview-questions-guide {
    .about {
      .description {
        white-space: unset;
        line-height: 150% !important;
      }
    }
  }
}

@include bp($bp-laptop) {
  .discover-hero {
    .container .row .heading {
      .h2 {
        font-size: 40px;
      }

      .subtitle {
        font-size: 21px;
      }
    }

    &.ty-newsletter,
    &.ty-offer-expired,
    &.ty-downloadable {
      .container .row {
        .heading {
          h1 {
            font-size: 32px;
          }
        }
      }
    }
  }

  .thank-you-resources.most-popular {
    padding-bottom: 130px;

    .body {
      .order-3 {
        display: none;
      }
    }
  }
}

@include bp($bp-mobile) {
  .discover-hero {
    &.ty-downloadable-resources {
      .image-container {
        .heading {
          .body-2 {
            width: 90%;
          }

          .form {
            button {
              width: auto;
            }
          }
        }
      }
    }
  }

  .thank-you-resources.most-popular {
    .col {
      margin-bottom: var(--spacing-24);
    }
  }
}

@include bp($bp-phone) {
  .discover-hero {
    padding-top: 398px !important;

    .wall {
      height: 100% !important;
      width: 100% !important;

      img {
        object-position: 50% 0 !important;
        object-fit: none !important;
      }
    }

    .heading {
      .h2 {
        font-size: 32px !important;
        width: 100% !important;
      }

      .body-2 {
        font-size: 16px !important;
        line-height: 150% !important;
      }

      .form {
        button {
          margin-top: var(--spacing-16) !important;
        }
      }
    }

    &.higher {
      .container.image-container {
        height: auto !important;
      }
    }

    &.offer-expired {
      padding-top: 492px !important;

      img {
        object-position: 50% 100% !important;
        object-fit: cover !important;
      }

      .container.image-container {
        top: calc(-492px + 46px) !important;
      }

      .heading {
        .h2 {
          margin-top: var(--spacing-36) !important;
          font-size: 44px !important;
        }

        .body-2 {
          font-size: 18px !important;
          line-height: 150% !important;
          margin-top: var(--spacing-36) !important;
        }
      }
    }

    &.ty-newsletter,
    &.ty-downloadable-resources,
    &.ty-offer-expired,
    &.ty-downloadable {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      padding-top: 492px !important;
    }

    &.ty-newsletter {
      .wall {
        height: 100% !important;
        padding-top: 354px !important;

        img {
          object-position: 79% 0 !important;
          object-fit: cover !important;
        }
      }

      .container.image-container {
        top: calc(-492px + 100px) !important;
      }

      .heading {
        .body-2 {
          font-size: 21px !important;
          line-height: 140% !important;
        }
      }
    }

    &.ty-downloadable-resources {
      padding-top: 143px !important;

      .wall {
        height: 100% !important;
        padding-top: 300px !important;

        img {
          object-position: 79% 0 !important;
          object-fit: cover !important;
        }
      }

      .heading {
        .body-2 {
          width: 100%;
          font-size: 21px !important;
          line-height: 140% !important;
        }

        .form {
          button {
            width: 100%;
          }
        }
      }
    }

    &.ty-offer-expired,
    &.ty-downloadable {
      .wall {
        height: 100% !important;
        padding-top: 176px !important;

        img {
          object-position: 79% 0 !important;
          object-fit: cover !important;
        }
      }

      .container.image-container {
        top: calc(-492px + 100px) !important;
      }

      .heading {
        .body-2 {
          font-size: 21px !important;
          line-height: 140% !important;
        }
      }
    }

    &.data-science-interview-questions-guide,
    &.data-science-interview-questions-guide-yt,
    &.data-science-statistics-cheatsheet {
      padding-top: 320px !important;

      .container.image-container {
        height: auto !important;
        padding-bottom: var(--spacing-60) !important;

        .row > div {
          min-height: 388px !important;
        }
      }
    }

    &.data-science-booklet {
      padding-top: 274px !important;

      .container.image-container {
        height: auto;
        padding-bottom: var(--spacing-60) !important;

        .row > div {
          min-height: 388px !important;
        }
      }
    }

    &.data-science-sql-basics {
      padding-top: 330px !important;

      .container.image-container {
        height: auto !important;
        padding-bottom: var(--spacing-60) !important;

        .row > div {
          min-height: 388px !important;
        }
      }
    }

    &.data-science-career-guide,
    &.data-science-career-guide-yt {
      padding-top: 300px !important;

      .container.image-container {
        height: auto !important;
        padding-bottom: var(--spacing-60) !important;

        .row > div {
          min-height: 388px !important;
        }
      }
    }
  }

  .thank-you-resources.most-popular {
    padding-top: 100vh;
  }

  .content {
    .content-background {
      .tips {
        padding: var(--spacing-80) 0 var(--spacing-80);

        h2 {
          width: 100%;
          text-align: left;
        }

        ol {
          margin-top: var(--spacing-32);

          li {
            margin-bottom: var(--spacing-24);
          }

          li:last-child {
            margin-bottom: 0;
          }
        }

        .content {
          height: 154px !important;
        }
      }

      .site-section {
        padding: 0;

        .container {
          height: 345px !important;
          border-radius: unset;

          .info {
            padding: 0;
          }

          .logos {
            margin-bottom: 0;
            justify-content: center;
          }
        }
      }

      .feedback {
        padding: var(--spacing-80) var(--spacing-24);

        .title-review {
          text-align: left;
          font-size: 28px;
          margin-bottom: var(--spacing-36);
        }

        .col {
          margin-bottom: var(--spacing-12);
          flex: unset;
        }

        .col:first-child {
          padding-right: 13px;
        }

        .col:last-child {
          padding-left: 13px;
          margin-bottom: 0;
        }
      }
    }

    .about {
      .about-author {
        padding: var(--spacing-80) var(--spacing-24) 75px var(--spacing-24);

        .title {
          text-align: left;
          margin-bottom: 0;
        }

        .author {
          display: unset !important;
          align-items: center;
          margin-bottom: var(--spacing-44);

          .image {
            width: 158px;
            height: 198px;
            margin-top: var(--spacing-44);
          }

          .info-author {
            margin-left: 0;
            margin-top: var(--spacing-32);

            .name {
              font-size: 24px;
            }

            .subtitle {
              margin-bottom: 0;
            }
          }
        }
      }
    }

    .prefooter {
      padding-top: var(--spacing-80) !important;

      .h2 {
        margin-bottom: var(--spacing-40) !important;
      }

      .subtitle {
        margin: 0 auto var(--spacing-40) !important;
      }

      .bg {
        margin: 40px auto 0 !important;

        .svg {
          height: 200px;
        }
      }
    }
  }
}

.fa {
  @import '../assets/sass/fa/pages/landing-page.scss';
}
</style>
